((w) => {
    const utils = new GtmUtils();
    var externalTrackingSystemName = 'gtm';

    if (w.ExternalTrackingEventBus) {
        w.ExternalTrackingEventBus.register(externalTrackingSystemName);
    }

    w.PubSub.subscribe('externaltracking.shopcart', (topic, data) => {
        const channelParts = topic.split('.');
        const topicAction = channelParts[channelParts.length - 1];
        var topicActionLowerCase = topicAction.toLowerCase();

        const mapConvertItems = (items) => items.map(trackableOrderLine =>
            utils.convertToGtmEecProduct(trackableOrderLine.product, {
                'price': trackableOrderLine.unitPrice,
                'quantity': trackableOrderLine.quantity
            }));

        try {
            switch (topicActionLowerCase) {
                case 'addtocart':
                    var gtmAddProducts = mapConvertItems(data.items);
                    pushGtmEvent('add', gtmAddProducts, data.source);
                    break;
                case 'removefromcart':
                    var gtmRemoveProducts = mapConvertItems(data.items);
                    pushGtmEvent('remove', gtmRemoveProducts, data.source);
                    break;
                case 'updatecartquantity':
                    if (data.addedQtyItems && data.addedQtyItems.length) {
                        var gtmAddQtyProducts = mapConvertItems(data.addedQtyItems);
                        pushGtmEvent('add', gtmAddQtyProducts, data.source);
                    }
                    else if (data.removedQtyItems && data.removedQtyItems.length) {
                        var gtmRemoveQtyProducts = mapConvertItems(data.removedQtyItems);
                        pushGtmEvent('remove', gtmRemoveQtyProducts, data.source);
                    }
                    break;
                default:
                    throw 'Unknown shopcart action received via pubsub: ' + topicAction;
            }

        } catch (e) {
            console.error('[GTM]: Failed to push cart changes to dataLayer. Reason: ' + e);
        }
        finally {
            if (w.ExternalTrackingEventBus) {
                w.ExternalTrackingEventBus.eventHandled(externalTrackingSystemName, topicActionLowerCase, data);
            }
        }

        function pushGtmEvent(type, products, source) {
            var gtmEvent;
            switch (type) {
                case 'add':
                    gtmEvent = {
                        'event': 'eec.addToCart',
                        'ecommerce': {
                            'currencyCode': utils.getCurrencyCode(data),
                            'add': { 'products': products }
                        }
                    };
                    break;
                case 'remove':
                    gtmEvent = {
                        'event': 'eec.removeFromCart',
                        'ecommerce': {
                            'currencyCode': utils.getCurrencyCode(data),
                            'remove': { 'products': products }
                        }
                    };
                    break;
                default:
                    throw 'Unknown GtmEvent type: ' + type;

            }

            w.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            w.dataLayer.push(gtmEvent);

            if (source === 'callback') {
                w.PubSub.publish('externaltracking.complete');
            }
        }
    });
})(window);